module.exports = __webpack_public_path__ + "static/media/silueta_elena.de0a2837.png";